<template>


  <h2>List of persons with a status of New on this Contract</h2>

  <div class="returnLinkButton">
    <div class="material-icons forIconEdit text-success"> arrow_back_ios_new </div>
    <a herf="#" class="text-primary" @click="ReturnToProcessMasterListPage">
      Return to Process Master List Page
    </a>
  </div>

  <ContractHelperComponent v-if="this.retrievedContractInfo" :prop-contract-info="contractInfo"></ContractHelperComponent>

  <DataTableComponent v-if="this.getAllUrl" 
  :data-url="this.getAllUrl" 
  :column-list-d-b="this.personDataColumnNames" 
  :column-list-pretty="this.personDataColumnNamesPretty" 
  order-direction="asc" 
  :date-column-indexes="[6]"
  :center-column-indexes="[5,6]"
  :order-column-index="0" 
  column-name-id="personId" 
  ref="personsDatatable"
  :show-paging="false"
  :rows-per-page="-1"
  plural-data-name="people"
  >
    
    <template v-slot:extraColumnHeaders>
      <th>Armed</th>
    </template>

    <template #extraColumns="extraColumnRowData">

      <td :data-sort="extraColumnRowData.armed">
        <div class="form-check activeCheckBoxContainer">

          <input class="form-check-input" type="checkbox" value="" :id="'flexCheckDefault_' + extraColumnRowData.personId" @change="ActiveCheckboxHit(extraColumnRowData)" v-model="extraColumnRowData.armed">

        </div>
      </td>

    </template>

    <template #actionColumnEditSlot="actionColumnEditSlot">

      <td class="tdclass actionColumn">

          <div class="text-primary" @click="this.ClickedEditPerson(actionColumnEditSlot)" :id="'btnEditPerson_' + actionColumnEditSlot.personId">Edit </div>

        </td>

    </template>

  </DataTableComponent>

</template> 
  
<script> 
  
  import { store } from "@/store/store.js";
  import $ from "jquery";
  import { ajaxGetAndReturn } from "@/components/helpers/utilities";
  import DataTableComponent from "@/components/dataSupport/DataTable.vue";
  import ContractHelperComponent from "@/components/ContractHelper/ContractHelper.vue";
  import TooltipHelper from "@/components/dataSupport/TooltipHelper.vue";
  //import ModalBootstrap from "@/components/dataSupport/ModalBootstrap.vue"

  export default {
    name: "PersonsByContractNew",
    components: {
      DataTableComponent,
      ContractHelperComponent,
      TooltipHelper,
    }, 
    data(){
      return{
        store,
        contractInfo: {},
        getAllUrl:"",
        personDataColumnNames:['lastName','firstName', 'securityTypeName', 'spotDTSID','countryName', 'loaAWYN','armingConfirmedDatePretty'],
        personDataColumnNamesPretty:['Last Name','First Name', 'Security Type', 'LOA','Nationality', 'LOA-AW', 'Arming Confirmed Date'],
        retrievedContractInfo:false,
        isMounted: false
      }
    },
    computed:{
      contractId(){
        var computedValue = 0; 

        if(this.store.tempContractId != undefined &&this.store.tempContractId != 0){
          computedValue = this.store.tempContractId;
        }
        else{
          computedValue = this.$route.params.contractId;
        }

        return computedValue;
      },
      companyId(){
        var computedValue = 0; 

        if(this.store.tempCompanyId != undefined && this.store.tempCompanyId != 0){
          computedValue = this.store.tempCompanyId;
        }
        else{
          computedValue = this.$route.params.companyId;
        }

        return computedValue;
      }
    },
     created(){
      ///contracts/getHelperDto/{contractId}
      ajaxGetAndReturn(store.webAPIUrl + "contracts/getHelperDto/" + this.contractId, (result) =>{
        //console.log(result);
        this.contractInfo = result;
        this.retrievedContractInfo = true; 
      });

      this.getAllUrl = store.webAPIUrl + "people/GetAllPersonsByContractAndStatus?contractId=" + this.contractId + "&statusFilter=New";
    },
    mounted() {
      //var urlParams = this.$route.params.contractId;
       
      $("");
      
      this.isMounted = true;
    },

    methods:{
      ClickedEditPerson(_person){
        this.store.tempPersonId = _person.personId;
        this.$router.push({ name: 'PersonEditPage', params: { personId: _person.personId } })  
      },
      ReturnToProcessMasterListPage(){
        this.$router.push({ name: 'processMasterList' });
      },
      ActiveCheckboxHit(rowData){
        //console.log(rowData);

        //get dataTable row by Id:
        var DataRowToEdit = this.$refs.personsDatatable.loadedData.find(x => x.personId == rowData.personId);
        //update data in table:
        DataRowToEdit.armed = rowData.armed != null? rowData.armed : true;
        DataRowToEdit.armedYN = rowData.armed ? "Yes" : "No";
        DataRowToEdit.armingConfirmedDatePretty = this.GetTodaysDatePretty();
        //update data in DB:
        //PUT: api/People/5 
        var actionUrl = store.webAPIUrl + "People/putPersonDto/" + rowData.personId; 
        //set update date to now
        rowData.updateDate = new Date();
        rowData.armingConfirmedDate = new Date();
        rowData.isActive = true; 
        rowData.armed = DataRowToEdit.armed; 
        
        $.ajax({
            method: "PUT",
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            url: actionUrl,
            data: JSON.stringify(rowData),
            success: (result) => {

                this.successMessage = "Successfully Submitted Change to DB on: " + Date().toLocaleString() + "; " + result;
            },
        });
      },
      GetTodaysDatePretty(){
        var today = new Date();
        var dd = today.getDate();

        var mm = today.getMonth()+1; 
        var yyyy = today.getFullYear();
        if(dd<10) 
        {
            dd='0'+dd;
        } 

        if(mm<10) 
        {
            mm='0'+mm;
        } 

        return(mm+"/"+dd+"/"+yyyy);
      },
    },
    
    unmounted(){

      //console.log("force update user contracts table"); 
      this.$forceUpdate();
    }
  }
</script>
  
<style scoped>
  .returnLinkButton{
    display:flex;
    margin-bottom:15px;
  }
  .actionButton{
    width:max-content;
    padding:5px;
    cursor:pointer;
  }
  .actionButton{
    padding:5px;
  }
  .activeCheckBoxContainer{
    padding-bottom: 1.25rem;
  }
  .form-check-input{
    cursor:pointer;
    margin-right:5px;
  }
</style>
